import React, { useState } from "react";

interface Video {
  id: number;
  url: string;
  title: string;
  description: string;
  thumbnail?: string;
}

const sampleVideos: Video[] = [
  {
    id: 1,
    url: "https://www.youtube.com/embed/tZnBzNOZTfE",
    title: "Doctor’s Guide to Migraines | මොකක්ද මේ Migraine කියන්නේ",
    description:
      "Doctor’s Guide to Migraines | Causes, Symptoms & Triggers | Ayurvedic Treatment | Ceylon Hospital",
  },
  {
    id: 2,
    url: "https://www.youtube.com/embed/TrBTJ5EpIZ0",
    title: "දින 4න් කොන්දේ අමාරුව සුව කරන නැදුම්ගමුවේ දයා මාදුලුව වෛද්‍යතුමිය!",
    description: "Ceylon hospital",
  },
  {
    id: 3,
    url: "https://www.youtube.com/embed/NbLioKty6Gc",
    title: "තද බල හිසේ වේදනාවකින් සිටිමින් සුවය ලැබූ රෝගියාගේ කතාව.",
    description:
      "Cluster Headache Sufferer  Sought Pain Relief | Success Story | Ayurvedic Treatment | Ceylon Hospital",
  },
  {
    id: 4,
    url: "https://www.youtube.com/embed/R2NolPU7eHY",
    title:
      "කොලෙස්ටරෝල් මට්ටම සහ විවිධ සංකූලතාවයන් නිසා පිඩා විදි රෝගියාගේ කතාව.",
    description:
      "Cholesterol Healing journey | Ayurvedic Treatment | Ceylon Hospital",
  },
  {
    id: 5,
    url: "https://www.youtube.com/embed/MvYQXMiw12c",
    title: "අධික රිදුම් දෙන කොන්දේ වේදනාව සුව වූ අම්මාගේ කතාව",
    description:
      "Success Story | Nerve Pain Recovery Journey | Ayurvedic Treatment | Ceylon Hospital",
  },
];

export const VideoGalleryCom: React.FC = () => {
  const [currentVideo, setCurrentVideo] = useState<Video>(sampleVideos[0]);

  return (
    <div className="min-h-screen bg-gray-50 px-3 py-1 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mt-5">
          {/* <TitleComponent 
            Title={"Video Gallery"} 
            Subtitle={"Explore our hospital videos"} 
          /> */}

          <div className="flex flex-col lg:flex-row gap-2 mt-8">
            {/* Left Side - Main Video Player */}
            <div className="lg:w-2/3">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="relative pt-[56.25%]">
                  {" "}
                  {/* 16:9 Aspect Ratio */}
                  <iframe
                    src={currentVideo.url}
                    title={currentVideo.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute top-0 left-0 w-full h-full"
                  />
                </div>
                <div className="p-6">
                  <h2 className="lg:text-2xl text-lg font-bold text-gray-800  Blinker-Bold">
                    {currentVideo.title}
                  </h2>
                  <p className="text-gray-600 Blinker-Regular">
                    {currentVideo.description}
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side - Video List */}
            <div className="lg:w-1/3">
              <div className="bg-white rounded-xl shadow-lg p-4">
                <h3 className="text-2xl font-semibold text-gray-800 mb-2 Blinker-SemiBold">
                  More Videos
                </h3>
                <div className="space-y-1 max-h-[600px] overflow-y-auto pr-2">
                  {sampleVideos.map((video) => (
                    <div
                      key={video.id}
                      onClick={() => setCurrentVideo(video)}
                      className={`flex gap-3 p-1 rounded-lg cursor-pointer transition-all ${
                        currentVideo.id === video.id
                          ? "bg-blue-50 border border-blue-200"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <div className="w-1/3 relative rounded-md overflow-hidden">
                        <div className="pt-[56.25%] relative">
                          <img
                            src={`https://img.youtube.com/vi/${
                              video.url.split("/embed/")[1]
                            }/mqdefault.jpg`}
                            alt={video.title}
                            loading="lazy"
                            className="absolute top-0 left-0 w-full h-full object-cover"
                          />
                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-10 h-10 bg-black bg-opacity-70 rounded-full flex items-center justify-center">
                              <svg
                                className="w-5 h-5 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M6.3 2.8L14.9 10l-8.6 7.2V2.8z" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="w-2/3">
                        <h4 className="text-gray-800 line-clamp-2 Blinker-Regular text-[.9rem]">
                          {video.title}
                        </h4>
                        <p className="text-sm text-gray-500 Blinker-Regular">
                          Ceylon Hospital
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
